import TimeClockEntryStore from "../store/store";
import { mutatorAction } from "satcheljs";

export default mutatorAction('RESET_TIME_CLOCK_ENTRY', function resetTimeClockEntryStore() {
        TimeClockEntryStore().timeClockEntry = null;
});